import cx from 'classnames'
import type { ReactNode } from 'react'

import classes from './styles.module.scss'

type PageProps = {
  children?: ReactNode
  maxWidth?: number
  className?: string
  rootClassName?: string
}

function Page(props: PageProps) {
  return (
    <div
      className={cx(classes.root, props.rootClassName && props.rootClassName)}
      style={props.maxWidth && { maxWidth: `${props.maxWidth}px` }}
    >
      <div className={cx(classes.content, props.className, 'mt-paper')}>{props.children}</div>
    </div>
  )
}

export default Page
